"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[191],{

/***/ 45379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dialog": function() { return /* binding */ Dialog; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67573);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56628);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2736);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _images_IconLoader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64162);







var Dialog = function(param) {
    var title = param.title, description = param.description, children = param.children, _open = param.open, open = _open === void 0 ? false : _open, _mode = param.mode, mode = _mode === void 0 ? "content" : _mode, onOpenChange = param.onOpenChange;
    if (!children) return;
    var _obj, _obj1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("radix-dialog", (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, "hidden", !open)),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_5__/* .Root */ .fC, {
            onOpenChange: onOpenChange,
            open: open,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_5__/* .Overlay */ .aV, {
                    className: "relative z-50",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_6__/* .motion.div */ .E.div, {
                        className: "fixed inset-0 bg-black w-screen h-screen",
                        animate: {
                            opacity: 0.4
                        },
                        initial: {
                            opacity: 0
                        },
                        exit: {
                            opacity: 0
                        },
                        transition: {
                            ease: "circOut",
                            duration: 2
                        }
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_5__/* .Content */ .VY, {
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("fixed z-50 w-screen top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2 max-w-90vw", (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "max-h-75vh aspect-ratio-16-9 max-w-inner", mode === "video"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "max-w-90vw md:max-w-75vw lg:max-w-text", mode === "content"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "inline-flex justify-center", mode === "form"), _obj)),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_6__/* .motion.div */ .E.div, {
                        animate: {
                            y: open ? 0 : 60
                        },
                        initial: {
                            y: 60
                        },
                        exit: {
                            y: 0
                        },
                        transition: {
                            ease: [
                                0.25,
                                0.46,
                                0.45,
                                0.94
                            ],
                            duration: 0.5
                        },
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj1, "text-neutral-50 overflow-y-auto overflow-scrolling-touch filter shadow-md bg-white p-10 h-auto max-h-75vh ", mode === "content"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj1, "overflow-y-auto overflow-scrolling-touch h-auto max-h-75vh relative", mode === "form"), _obj1)),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_6__/* .motion.div */ .E.div, {
                            animate: {
                                opacity: 1
                            },
                            initial: {
                                opacity: 0
                            },
                            exit: {
                                opacity: 0
                            },
                            transition: {
                                ease: "circOut"
                            },
                            children: [
                                title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_5__/* .Title */ .Dx, {
                                    className: "sr-only",
                                    children: title
                                }),
                                description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_5__/* .Description */ .dk, {
                                    className: "sr-only",
                                    children: description
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_5__/* .Close */ .x8, {
                                    className: "py-3 px-3 text-neutral-10 hover:text-neutral-25 bg-white hover:bg-neutral-95 transition-colors absolute top-0 right-0 z-10",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_images_IconLoader__WEBPACK_IMPORTED_MODULE_3__/* .IconLoader */ .p, {
                                        icon: "close",
                                        className: "text-current w-8 h-8 block"
                                    })
                                }),
                                mode === "content" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "h-full prose prose-sm md:prose break-words",
                                    children: children
                                }),
                                mode === "form" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: children
                                }),
                                mode === "video" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "relative aspect-ratio-16-9",
                                    children: children
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.memo(Dialog));


/***/ })

}]);